import React from 'react'
import * as Icon from '@material-ui/icons'
import PropTypes from 'prop-types'

const IconTag = ({ name, className }) => {
  const IconItem = Icon[name || 'ChevronRight']
  return <IconItem className={className} />
}

IconTag.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default IconTag
